import React, { Fragment, useEffect, useState } from 'react';
import { Row, Col, Card } from "reactstrap";
import { useDispatch, useSelector } from 'react-redux';
import { getBranch } from 'Services/Features/Branch/Utils/branchUtils';
import CustomLoader from 'Component/Common/CustomLoader';
import FindBranch from './Filter/FindBranch';
import BranchContent from './BranchContent';
import {
    handleNextPagination,
    handleBackPagination,
    handleClickPagination
} from 'Component/DashboardQeza/Common/PaginationUtils';
import PaginationComponent from 'Component/Common/PaginationComponent';
import { setFilters } from 'Services/Features/Branch/branchSlice';

const BranchContain = () => {
    const dispatch = useDispatch();
    const branches = useSelector((state) => state.branch.branches);
    const loading = useSelector((state) => state.branch.loading);
    const error = useSelector((state) => state.branch.error);
    const [refetch, setRefetch] = useState(false);
    const pagination = useSelector((state) => state.branch.pagination);
    const filters = useSelector(state => state.branch.filters);
    
    useEffect(() => {
        dispatch(getBranch(filters));
        window.scrollTo(0, 0);
    }, [dispatch, refetch]);

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <Fragment>
            <Col md="12" className="project-list">
                <Card className="px-3">
                    <FindBranch />
                </Card>
            </Col>
            <Col xl="12" className="xl-80">
                <Row>
                    {loading ? (
                        <CustomLoader />
                    ) : loading === false && branches.length === 0 ? (
                        <Col md="12">
                            <div className="no-data-found d-flex flex-column align-items-center justify-content-center" style={{ height: '300px' }}>
                                <i className="fa fa-search" style={{ fontSize: '100px', color: '#ccc', marginBottom: '20px' }}></i>
                                <h5 style={{ fontSize: '24px' }}>Klinik Tidak Ditemukan</h5>
                            </div>
                        </Col>
                    ) : (
                        <BranchContent setRefetch={setRefetch} />
                    )}
                </Row>
                <div style={{ marginTop: '150px' }}> 
                    {loading === false && branches && branches.length > 0 && (
                        <PaginationComponent
                            pagination={pagination}
                            handleBackPagination={() => handleBackPagination(pagination, filters, dispatch, setFilters, setRefetch)}
                            handleClickPagination={(page) => handleClickPagination(page, filters, dispatch, setFilters, setRefetch)}
                            handleNextPagination={() => handleNextPagination(pagination, filters, dispatch, setFilters, setRefetch)}
                        />
                    )}
                </div>
            </Col>
        </Fragment>
    );
};

export default BranchContain;